import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import cx from 'classnames';

import segmentLabelMap from 'sharedParts/config/segmentLabelMap';
import StylingToCSSLabelText from 'styling/hocs/StylingToCSS/StylingToCSSLabelText';
import propTypeStyleLabel from 'styling/config/editorBlock/PropTypes/styleLabel';

import styles from './RatingSegment.scss';
import RatingSegmentItem from '../RatingSegmentItem';

const getSegmentStyle = (segmentType) => {
  switch (segmentType) {
    case segmentLabelMap.labelListEnd:
      return styles.containerSegmentsFirstAndLast;
    case segmentLabelMap.labelListEndMidpoint:
      return styles.containerSegmentsMidpoints;

    default:
      return '';
  }
};

const getSegmentMobileStyle = (segmentType, itemListCount) => {
  let remainingColumns = '';
  if (itemListCount === 0 || itemListCount === 5 || itemListCount === 10) {
    remainingColumns = '';
  }
  if (itemListCount < 5) remainingColumns = 5 - itemListCount;
  if (itemListCount > 5 && itemListCount < 10) remainingColumns = 10 - itemListCount;
  switch (segmentType) {
    case segmentLabelMap.labelListEnd:
      return `repeat(2, ${Math.round((itemListCount * 100) / 2) / 100}fr) ${
        remainingColumns !== '' ? `${remainingColumns}fr` : remainingColumns
      }`;
    case segmentLabelMap.labelListEndMidpoint:
      return `repeat(3, ${Math.round((itemListCount * 100) / 3) / 100}fr) ${
        remainingColumns !== '' ? `${remainingColumns}fr` : remainingColumns
      }`;

    default:
      return '';
  }
};

const RatingSegment = ({
  className,
  labelList = [],
  ratingItemClassName,
  styleLabel,
  segmentType,
  count,
}) => {
  if (!labelList || isEmpty(labelList)) {
    return null;
  }

  const segmentMobileStyle = useMemo(() => getSegmentMobileStyle(segmentType, count), [segmentType, count]);

  return (
    <div
      className={cx(
        className,
        styles.container,
        segmentType === segmentLabelMap.itemList && styles.hideSegmentsMobile,
      )}
    >
      <div
        className={cx(styles.segmentContainer, getSegmentStyle(segmentType))}
        style={{ gridTemplateColumns: segmentMobileStyle }}
      >
        {labelList.map((item) => (
          <div className={cx(ratingItemClassName, styles.segmentItem)} key={item.id}>
            <RatingSegmentItem className={styles.segmentText} segmentStyle={styleLabel} text={item.value} />
          </div>
        ))}
      </div>
    </div>
  );
};

RatingSegment.propTypes = {
  count: PropTypes.number.isRequired,
  labelList: PropTypes.array,
  ratingItemClassName: PropTypes.string,
  className: PropTypes.string,
  styleLabel: propTypeStyleLabel,
  segmentType: PropTypes.string,
};

export default StylingToCSSLabelText(RatingSegment);
